/**
 * Safely parses any date input (String, Date, or Number) into a Date object.
 */
export function parseToDate(value: any): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Formats a date to 'dd-mm-yyyy'.
 * Example: '27-05-2026'
 */
export function formatDate(value: Date | string | number | null | undefined, fallback: string = '-'): string {
  const date = parseToDate(value);
  if (!date) return fallback;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

/**
 * Formats a date and time to 'dd-mm-yyyy hh:mm AM/PM'.
 * Example: '27-05-2026 01:30 PM'
 */
export function formatDateTime(value: Date | string | number | null | undefined, fallback: string = '-'): string {
  const date = parseToDate(value);
  if (!date) return fallback;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12
  const formattedHours = String(hours).padStart(2, '0');

  return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
}
